import tw, { styled } from 'twin.macro';

const HorizontalConnector = styled.div`
  ${tw`h-4`}
  width: ${props => (props.wide ? '25rem' : '11.2rem')};
  border-bottom: 2px solid #888888;
`;
export default HorizontalConnector;
